import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsDate, IsString } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { CandidateType, SourceType } from "@gtpl/shared-models/common-models";
import { GoneException } from "@nestjs/common";

export class ProfilesDTO{

    @ApiProperty()
    @IsNotEmpty({message: 'Profile Id should not be empty'})
    @IsAlphanumeric()
    @IsOptional()
    profileId: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Candidate Name should not be empty'})
    candidateName: string;

    @ApiProperty()
    @IsString({message: 'Job Description should not be empty'})
    jobDescription: string;

    @ApiProperty()
    @IsDate()
    profileDate: Date;

    @ApiProperty()
    @IsNotEmpty({message: 'Mobile Number should not be empty'})
    mobileNumber: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Qualification Name should not be empty'})
    qualification: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Technologies should not be empty'})
    skills: string;

    // @ApiProperty()
    // @IsNotEmpty({message: 'Stack should not be empty'})
    // stack: string;

    @ApiProperty()
    altMobileNumber: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Expected CTC should not be empty'})
    expectedCTC: number;

    @ApiProperty({
        enum: CandidateType,
        default: CandidateType.Experience
    })
    candidateType: CandidateType;

    @ApiProperty()
    @IsNotEmpty({message: 'Current CTC should not be empty'})
    currentCTC: number; 
    
    @ApiProperty()
    @IsNotEmpty({message: 'Notice Period should not be empty'})
    noticePeriod: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Experience should not be empty'})
    experience: number;

    @ApiProperty({
        enum: SourceType,
        default: SourceType.Direct
    })
    sourceType: SourceType;

    @ApiProperty()
    @IsNotEmpty({message: 'Referred By should not be empty'})
    referredBy: string;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}